import styled from "styled-components";

/* 검정 바탕에 노란 차트 */
export const DarkBand = styled.section`
  --chart-ink: #ffffff;
  --chart-muted: rgba(255, 255, 255, 0.62);
  --chart-rule: rgba(255, 255, 255, 0.18);
  --chart-fill: #fcd13f;
  --chart-line: #fcd13f;
  --chart-dot: #1f1a12;

  background: var(--text-primary);
  color: #ffffff;
  padding: var(--space-20) 0;

  @media screen and (max-width: 768px) {
    padding: var(--space-12) 0;
  }
`;

export const DarkHeading = styled.h2`
  font-size: clamp(1.875rem, 3.4vw, 2.75rem);
  font-weight: var(--font-weight-black);
  line-height: 1.2;
  letter-spacing: -0.035em;
  color: #ffffff;
  word-break: keep-all;
  text-wrap: pretty;

  & mark {
    color: var(--text-primary);
  }
`;

export const DarkSub = styled.p`
  margin-top: var(--space-3);
  font-size: 1.0625rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.72);
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-12);
  margin-top: var(--space-12);

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-10);
    max-width: 480px;
  }
`;

export const ChartBlock = styled.figure`
  margin: 0;
`;

export const ChartTitle = styled.figcaption`
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  color: var(--chart-ink);
  margin-bottom: var(--space-4);
`;

export const ChartSvg = styled.svg`
  width: 100%;
  height: auto;
  display: block;
  overflow: visible;
`;

export const AxisLabel = styled.text`
  fill: var(--chart-muted);
  font-size: 11px;
  font-weight: 500;
`;

export const ValueLabel = styled.text`
  fill: var(--chart-ink);
  font-size: 12px;
  font-weight: 700;
`;

/* 연혁 (흰 바탕) */
export const HistoryTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: var(--font-weight-extrabold);
  letter-spacing: -0.02em;
  color: var(--text-primary);
  margin-bottom: var(--space-4);
`;

export const History = styled.div`
  max-width: 44rem;
`;

export const YearRow = styled.div`
  display: grid;
  grid-template-columns: 6rem 1fr;
  gap: var(--space-4);
  padding: var(--space-5) 0;
  border-top: 2px solid var(--text-primary);

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: var(--space-2);
  }
`;

export const YearLabel = styled.div`
  font-size: 1.25rem;
  font-weight: var(--font-weight-black);
  letter-spacing: -0.02em;
  color: var(--text-primary);
  line-height: 1.4;
`;

export const EventList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

export const EventItem = styled.li`
  display: grid;
  grid-template-columns: 3.25rem 1fr;
  gap: var(--space-3);
  word-break: keep-all;
`;

export const EventMonth = styled.span`
  font-size: 0.875rem;
  color: var(--text-muted);
  line-height: 1.6;
`;

export const EventText = styled.span`
  font-size: 0.9375rem;
  color: var(--text-secondary);
  line-height: 1.6;

  & b {
    color: var(--text-primary);
    font-weight: var(--font-weight-bold);
  }
`;
